<template>
  <div>
    <div class="row mb-10">
      <div v-for="(item, index) in coupons" :key="index" class="col-sm-12">
        <div
          class="coupon bg-white rounded mb-3 d-flex justify-content-between shadow-m"
        >
          <!-- بخش چپ - اطلاعات کوپن -->
          <div class="tengah py-3 d-flex w-100 justify-content-start col-md-11">
            <div class="mr-3 mt-3 pr-3">
              <div class="row font-weight-bold">
                {{ $t(`coupons.${index}.title`) }}
              </div>
              <CopyButton :text="item.code" />
              <div class="row mb-1 text-muted small">
                {{ $t(`coupons.${index}.text`) }}
              </div>
            </div>
          </div>

          <!-- بخش راست - تصویر و ریبون -->
          <div class="kanan col-md-1">
            <div class="ribbon ribbon-top-left">
              <span class="bg-danger">{{ $t("ribbon.new") }}</span>
            </div>
            <div class="info d-flex align-items-center">
              <div class="w-100" style="background-color: white">
                <div class="text-center pb-5 pt-8">
                  <img
                    :src="item.image"
                    :alt="$t(`coupons.${index}.title`)"
                    class="img-fluid"
                    height="56"
                    width="56"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CopyButton from "@/view/content/widgets/CopyButton";

export default {
  name: "CouponService",
  components: {
    CopyButton,
  },
  data() {
    return {
      copyTextTitle: "copyTextTitle", // کلید ترجمه
      showIcon: false,
    };
  },
  computed: {
    coupons() {
      return [
        {
          title: this.$t("coupons.0.title"),
          text: this.$t("coupons.0.text"),
          service: "robotLand",
          image: "/media/service-logo/robot-land.webp",
          code: "mtn_baz",
        },
        {
          title: this.$t("coupons.1.title"),
          text: this.$t("coupons.1.text"),
          service: "webLand",
          image: "/media/service-logo/web-land-1.webp",
          code: "site_baz",
        },
        {
          title: this.$t("coupons.2.title"),
          text: this.$t("coupons.2.text"),
          service: "social",
          image: "/media/service-logo/social-media-land.webp",
          code: "maneg_page",
        },
        {
          title: this.$t("coupons.3.title"),
          text: this.$t("coupons.3.text"),
          service: "graphicLand",
          image: "/media/service-logo/graphic-land-mix.webp",
          code: "graphic_design",
        },
        {
          title: this.$t("coupons.4.title"),
          text: this.$t("coupons.4.text"),
          service: "graphicLand",
          image: "/media/service-logo/graphic-land-mix.webp",
          code: "print",
        },
      ];
    },
  },
  methods: {
    copyText(type) {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(type).then(() => {
          this.copyTextTitle = "copiedTextTitle";
          this.showIcon = true;
          setTimeout(() => {
            this.copyTextTitle = "copyTextTitle";
            this.showIcon = false;
          }, 2000);
        });
      }
    },
  },
  watch: {
    "$i18n.locale": {
      handler() {
        this.$forceUpdate(); // برای به‌روزرسانی ترجمه‌ها در computed
      },
      immediate: true,
    },
  },
};
</script>

<style scoped>
.shadow-m {
  border-radius: 10px;
  box-shadow: 0 6px 30px 0 rgb(0 0 0 / 9%);
}

.coupon .kanan {
  max-width: 30% !important;
  position: relative;
}

.tengah {
  border-left: 1.5px dashed #c0c0c0;
}

.coupon .kanan .info::after,
.coupon .kanan .info::before {
  content: "";
  position: absolute;
  width: 20px;
  height: 20px;
  background: #eef0f8;
  border-radius: 100%;
}

.coupon .kanan .info::before {
  top: -10px;
  right: -10px;
}

.coupon .kanan .info::after {
  bottom: -10px;
  right: -10px;
}

/* ریبون */
.ribbon {
  min-width: 80px;
  height: 60px;
  overflow: hidden;
  position: absolute;
}

.ribbon::before,
.ribbon::after {
  position: absolute;
  z-index: -1;
  content: "";
  display: block;
  border: 5px solid #2980b9;
}

.ribbon span {
  position: absolute;
  display: block;
  width: 125px;
  padding: 5px 0;
  background-color: #e74c3c;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
  color: #fff;
  font: 700 12px/1 "Lato", sans-serif;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  text-transform: uppercase;
  text-align: center;
}

.ribbon-top-left {
  top: -2px;
  left: -2px;
}

.ribbon-top-left::before,
.ribbon-top-left::after {
  border-top-color: transparent;
  border-left-color: transparent;
}

.ribbon-top-left::before {
  top: 0;
  right: 0;
}

.ribbon-top-left::after {
  bottom: 0;
  left: 0;
}

.ribbon-top-left span {
  right: -3px;
  top: 13px;
  transform: rotate(-45deg);
}

/* RTL Support */
:where([dir="rtl"]) {
  direction: rtl;
  text-align: right;
}

:where([dir="rtl"]) .tengah {
  border-left: none;
  border-right: 1.5px dashed #c0c0c0;
}

:where([dir="rtl"]) .coupon .kanan .info::before,
:where([dir="rtl"]) .coupon .kanan .info::after {
  right: auto;
  left: -10px;
}

:where([dir="rtl"]) .ribbon-top-left {
  left: auto;
  right: -2px;
}

:where([dir="rtl"]) .ribbon-top-left span {
  right: auto;
  left: -3px;
  transform: rotate(45deg);
}
</style>
